import React from "react";
import { useSelector } from "react-redux";
import { ConnectedConfiguratorScreen } from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen";
import CustomAmountPriceContainer from "../Containers/AmountPrice/AmountPrice";
import CustomThemeProvider from "../ThemeProvider";
import { DesignerScreen as BaseDesignerScreen } from "@configuratorware/configurator-frontendgui/App/Modules/Designer/DesignerScreen";
import { CreatorScreen as BaseCreatorScreen } from "@configuratorware/configurator-frontendgui/App/Modules/Creator/CreatorScreen";
import CustomHeaderContainer from "../Containers/Header/Header";
import DesignAreaControlbox from "../Containers/DesignAreaControlBox/DesignAreaControlBox";
import BaseProductPartsListContainer from "@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList";

export default (props) => {
  const vertical = useSelector(
    (state) =>
      !state.device.screen.isMobileDevice ||
      state.device.screen.orientation === "landscape"
  );

  const CustomDesignerScreen = (props) => (
    <BaseDesignerScreen
      {...props}
      renderDesignAreaControlbox={() => <DesignAreaControlbox />}
      renderHeader={() => <CustomHeaderContainer />}
    />
  );

  const ConfiguratorScreen = (props) => (
    <BaseCreatorScreen
      {...props}
      renderHeader={() => <CustomHeaderContainer />}
    />
  );

  return (
    <>
      <ConnectedConfiguratorScreen
        {...props}
        CreatorScreen={ConfiguratorScreen}
        DesignerScreen={CustomDesignerScreen}
        renderAmountPrice={(props) => <CustomAmountPriceContainer {...props} />}
        vertical={vertical}
        renderProductParts={(
          dispatchAction,
          onOptionClassificationSelect,
          selectOptionClassification
        ) => (
          <BaseProductPartsListContainer
            onSelect={(optionClassification) =>
              onOptionClassificationSelect(
                dispatchAction,
                optionClassification,
                selectOptionClassification
              )
            }
            vertical={vertical}
          />
        )}
        ThemeProvider={CustomThemeProvider}
      />
    </>
  );
};
